import * as appFunc from "./DebugLogging";
/* =====================================
   D E F I N I T I O N
   ===================================== */

/* =====================================
   F U N C T I O N S
   ===================================== */

export class updateUseState
{
    /* Function: object(key, value, setter)
       Info: update an useState key's value. useState must be an object.
       * key: Object's Key
       * value: Value to be set into the object's defined key
       * setter: Set object of the useState to be updated with.
       Returns: void
    */
    static object(key, value, setter)
    {
        if (typeof setter !== "function") 
        {
            console.error("[UpdateUseState.object] Provided setter is not a function.");
            return;
        }
        const keys = Array.isArray(key) ? key : String(key).split(".");
        setter( prev => {
            if (typeof prev !== "object" || prev === null || Array.isArray(prev))
            {
                appFunc.dbprint(appFunc.severitiesLevel.PRINT_ERROR, "AppFunc", "[UpdateUseState.object] useState is not an object.");
                return prev;
            }
            else
            {
                const newState = { ...prev };
                let curr = newState;

                for (let i = 0; i < keys.length - 1; i++)
                {
                    const k = keys[i];
                    curr[k] = { ...(curr[k] || {}) }; // clone or initialize
                    curr = curr[k];
                }

                curr[keys[keys.length - 1]] = value;

                return newState;
                // return {...prev, [key]: value};
            }
        })
    }

    static singleSelectionToggleObject(key, selectedKey, setter) 
    {
        if (typeof setter !== "function") 
        {
            console.error("[UpdateUseState.singleSelectionToggle] Provided setter is not a function.");
            return;
        }

        const keys = Array.isArray(key) ? key : String(key).split(".");
        setter(prev => {
            if (typeof prev !== "object" || prev === null) 
            {
                console.error("[UpdateUseState.singleSelectionToggleObject] useState is not an object.");
                return prev;
            }
            else
            {
                const newState = { ...prev };
                let curr = newState;

                for (let i = 0; i < keys.length; i++)
                {
                    const k = keys[i];
                    curr[k] = { ...(curr[k] || {}) };
                    curr = curr[k];
                }

                let isKeySelected = curr[selectedKey] === true;
                // Reset all to false, then set only selectedKey to true
                for (let k in curr)
                {
                    curr[k] = false;
                }
                if (isKeySelected === false)
                {
                    curr[selectedKey] = !curr[selectedKey];
                }
                else
                {
                    // DO NOTHING
                }

                return newState;
            }
        })
    }

    /* Function: object(key, value, setter)
       Info: set an empty object into useState. useState must be an object.
       * setter: Set object of the useState to be updated with.
       Returns: void
    */
    static clearObject(setter)
    {
        if (typeof setter !== "function") 
        {
            console.error("[UpdateUseState.clearObject] Provided setter is not a function.");
            return;
        }
        setter( prev => {
            if (typeof prev !== "object" || prev === null || Array.isArray(prev))
            {
                appFunc.dbprint(appFunc.severitiesLevel.PRINT_ERROR, "AppFunc", "[UpdateUseState.clearObject] useState is not an object.");
                return prev;
            }
            else
            {
                return {};
            }
        })
    }

    /* Function: addList(value, setter)
       Info: add an item into useState. useState must be a list.
       * value: Value to be added into the list
       * setter: Set object of the useState to be updated with.
       Returns: void
    */
    static addList(value, setter)
    {
        if (typeof setter !== "function") 
        {
            console.error("[UpdateUseState.addList] Provided setter is not a function.");
            return;
        }
        setter( prev => {
            if (!Array.isArray(prev)) 
            {
                appFunc.dbprint(appFunc.severitiesLevel.PRINT_ERROR, "AppFunc", "[UpdateUseState.addList] useState is not a list.");
                return prev;
            }
            else
            {
                return [...prev, value];
            }
        });
    }

    /* Function: deleteList(value, setter)
       Info: remove an index from list into useState. useState must be a list.
       * index: index of the list to be removed
       * setter: Set object of the useState to be updated with.
       Returns: void
    */
    static deleteList(index, setter)
    {
        if (typeof setter !== "function") 
        {
            console.error("[UpdateUseState.deleteList] Provided setter is not a function.");
            return;
        }
        setter( prev => {
            if (!Array.isArray(prev)) 
            {
                appFunc.dbprint(appFunc.severitiesLevel.PRINT_ERROR, "AppFunc", "[UpdateUseState.deleteList] useState is not a list.");
                return prev;
            }
            else
            {
                if (prev.hasOwnProperty(index))
                {
                    return prev.filter((_, i) => i !== index);
                }
                else
                {
                    appFunc.dbprint(appFunc.severitiesLevel.PRINT_ERROR, "AppFunc", "[UpdateUseState.deleteList] overflow, index do not exist.");
                    return prev;
                }
            }
        });
    }

    /* Function: updateList(index, value, setter)
       Info: update an index's value and store into useState. useState must be a list.
       * index: index of the list to be removed
       * value: value to be set into the index
       * setter: Set object of the useState to be updated with.
       Returns: returns the old value
    */
    static updateList(index, value, setter)
    {
        let rtnVal;
        if (typeof setter !== "function") 
        {
            console.error("[UpdateUseState.updateList] Provided setter is not a function.");
            return;
        }
        setter( prev => {
            if (!Array.isArray(prev)) 
            {
                appFunc.dbprint(appFunc.severitiesLevel.PRINT_ERROR, "AppFunc", "[UpdateUseState.updateList] useState is not a list.");
                return prev;
            }
            else
            {
                if (prev.hasOwnProperty(index))
                {
                    rtnVal = prev[index];
                    return prev.map((item, i) => (i === index ? value : item));
                }
                else
                {
                    appFunc.dbprint(appFunc.severitiesLevel.PRINT_ERROR, "AppFunc", "[UpdateUseState.updateList] overflow, index do not exist.");
                    return prev;
                }
            }
        });
        return rtnVal;
    }

    /* Function: clearList(setter)
       Info: set empty list into useState. useState must be a list.
       * setter: Set object of the useState to be updated with.
       Returns: void
    */
    static clearList(setter)
    {
        if (typeof setter !== "function") 
        {
            console.error("[UpdateUseState.clearList] Provided setter is not a function.");
            return;
        }
        setter( prev => {
            if (!Array.isArray(prev)) 
            {
                appFunc.dbprint(appFunc.severitiesLevel.PRINT_ERROR, "AppFunc", "[UpdateUseState.clearList] useState is not a list.");
                return prev;
            }
            else
            {
                return [];
            }
        });
    }

    /* Function: stateToggleList(index, setter)
       Info: toggle a value in the list. useState must be a list.
       * index: index of the list to toggle in value
       * setter: Set object of the useState to be updated with.
       Returns: void
    */
    static stateToggleList(index, setter)
    {
        if (typeof setter !== "function") 
        {
            console.error("[UpdateUseState.stateToggleList] Provided setter is not a function.");
            return;
        }
        setter( prev => {
            if (!Array.isArray(prev)) 
            {
                appFunc.dbprint(appFunc.severitiesLevel.PRINT_ERROR, "AppFunc", "[UpdateUseState.stateToggleList] useState is not a list.");
                return prev;
            }
            else
            {
                if (prev.hasOwnProperty(index))
                {
                    return prev.map((v, idx) => (idx === index ? !v : v));
                }
                else
                {
                    appFunc.dbprint(appFunc.severitiesLevel.PRINT_ERROR, "AppFunc", "[UpdateUseState.stateToggleList] overflow, index do not exist.");
                    return prev;
                }
            }
        });
    }

    /* Function: singleSelectionToggleList(index, setter)
       Info: toggle a value in the list. useState must be a list.
       * index: toggle an index in the list and set all the other value to false
       * setter: Set object of the useState to be updated with.
       Returns: void
    */
    static singleSelectionToggleList(index, setter)
    {
        if (typeof setter !== "function") 
        {
            console.error("[UpdateUseState.singleSelectionToggleList] Provided setter is not a function.");
            return;
        }
        setter( prev => {
            if (!Array.isArray(prev)) 
            {
                appFunc.dbprint(appFunc.severitiesLevel.PRINT_ERROR, "AppFunc", "[UpdateUseState.singleSelectionToggleList] useState is not a list.");
                return prev;
            }
            else
            {
                if (prev.hasOwnProperty(index))
                {
                    return prev.map((v, idx) => idx === index);
                }
                else
                {
                    appFunc.dbprint(appFunc.severitiesLevel.PRINT_ERROR, "AppFunc", "[UpdateUseState.singleSelectionToggleList] overflow, index do not exist.");
                    return prev;
                }
            }
        });
    }
}

export class appEnum
{
    static createEnum(keys, start = 0) 
    {
        const e = {};
        for (let i = 0; i < keys.length; i++) e[keys[i]] = start + i;
        return Object.freeze(e);
    }

    // Optional: add reverse lookup (number -> key), like C compilers often expose in tooling
    static createEnumWithReverse(keys, start = 0) 
    {
        const e = {};
        for (let i = 0; i < keys.length; i++) 
        {
            const val = start + i;
            const k = keys[i];
            e[k] = val;
        }
        const rev = Object.fromEntries(Object.entries(e).map(([k, v]) => [v, k]));
        return Object.freeze(Object.assign(e, { __reverse__: Object.freeze(rev) }));
    }
}